import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  imports: [SidebarComponent, NavbarComponent, FooterComponent, RouterOutlet]
})
export class PublicLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
